module.exports = __webpack_public_path__ + "images/3Dtour-4e40b7f0f811cc9734a555919125e5ad.jpg";